import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[bui-tbody]'
})

export class DataTbodyDirective {
  @HostBinding(`class.ant-table-tbody`) true;
}
